module.exports = __webpack_public_path__ + "img/circle1.d445efb3.png";